import { render, staticRenderFns } from "./FormSecondaryEventBlock.vue?vue&type=template&id=2cab3a91"
import script from "./FormSecondaryEventBlock.vue?vue&type=script&lang=js"
export * from "./FormSecondaryEventBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports